import chatService from './ws';

export default chatService;